import { setupTimeGetter } from './util/time';
import { setupLogger, LogLevel } from 'lib-common';

declare global {
  interface Window {
     _env_: any;   // <--- ADD THIS LINE
    env: ApplicationEnv.Env;
  }
  namespace ApplicationEnv {
    interface Env {
      PAPI_EE_REPORTER?: string;
      API_GATEWAY_URL: string;
      SAP_CDC_CLIENT_ID: string;
      SAP_CDC_DOMAIN: string;
      SAP_CDC_LOGOUT: string;
      STUB_TIME?: string;
      LOG_LEVEL?: keyof LogLevel;
      IDLE_TIMEOUT_SEC: string;
      NODE_ENV?: string;
      SAPI_EE_PRIMER?: string;
      UNDER_MAINTENANCE?: string;
      FEATURE_FLAGS_URL: string;
      FEATURE_FLAGS_CLIENT_KEY: string;
    }
  }
}

declare const process: {
  env: Record<string, string | undefined>;
};

const runtime = window._env_ || process.env;

const env: ApplicationEnv.Env = {
  API_GATEWAY_URL: process.env.REACT_APP_API_GATEWAY_URL || '',
  SAP_CDC_CLIENT_ID: process.env.REACT_APP_SAP_CDC_CLIENT_ID || '',
  SAP_CDC_DOMAIN: process.env.REACT_APP_SAP_CDC_DOMAIN || '',
  SAP_CDC_LOGOUT: process.env.REACT_APP_SAP_CDC_LOGOUT || '',
  STUB_TIME: process.env.REACT_APP_STUB_TIME,
  LOG_LEVEL: process.env.REACT_APP_LOG_LEVEL as keyof LogLevel,
  IDLE_TIMEOUT_SEC: process.env.REACT_APP_IDLE_TIMEOUT_SEC || '',
  NODE_ENV: process.env.NODE_ENV,
  UNDER_MAINTENANCE: process.env.REACT_APP_UNDER_MAINTENANCE,
  FEATURE_FLAGS_URL: process.env.REACT_APP_FEATURE_FLAGS_URL || '',
  FEATURE_FLAGS_CLIENT_KEY: process.env.REACT_APP_FEATURE_FLAGS_CLIENT_KEY || '',
  SAPI_EE_PRIMER: process.env.REACT_APP_SAPI_EE_PRIMER,
  PAPI_EE_REPORTER: process.env.REACT_APP_PAPI_EE_REPORTER,
};

export const configureEnvironment = (): Promise<ApplicationEnv.Env> =>
  Promise.resolve().then(() => {
    window.env = env;
    
    setupLogger({ level: env.LOG_LEVEL });
    setupTimeGetter();

    logger.debug({
      message: 'Environment configured',
      data: {
        NODE_ENV: env.NODE_ENV,
        LOG_LEVEL: env.LOG_LEVEL,
      },
    });
    return env;
  });
